import { createSupabaseBrowserClient } from '@/client/supabase'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'expo-router'
import * as Sentry from '@sentry/react-native'
import { sessionKeys } from '@/hooks/useClientSession.ts'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const router = useRouter()

  const logout = async () => {
    const supabase = createSupabaseBrowserClient()
    const { error } = await supabase.auth.signOut()

    if (error) {
      Sentry.captureException(error)
    }

    // Invalidate and reset the session query
    // queryClient.invalidateQueries({ queryKey: ['session'] })
    queryClient.resetQueries({ queryKey: sessionKeys.useSession })

    // Clear user from Sentry
    Sentry.setUser(null)

    // Redirect to home page
    router.replace('/')
  }

  return logout
}
